import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { MainContainer, MainHeading } from '../../style/GlobalStyles';
import { Box, Button, Checkbox, CircularProgress, Divider, FormControlLabel, Typography } from '@mui/material';
import logo from '../../assets/logo/Logo.svg';
import logo360 from '../../assets/logo/PRIME36oBlueLogo.svg';
import { post } from '../../api';
import RenderContent from '../../components/RenderContent';
import { useAuth } from '../../hooks/useAuth';
import { LoadingButton } from '@mui/lab';

function TermsPage() {
    const [loading, setLoading] = useState(false);

    const [termRecord, setTermRecord] = useState();
    const [agreedToTerms, setAgreedToTerms] = useState(false);
    const [actionLoading, setActionLoading] = useState(false);

    const { getUserDetailsNotAsync, setUserDetailsNotAsync } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const userDetails = getUserDetailsNotAsync();

    const redirectPath = useMemo(() => {
        const path = location.state?.path;
        if (!path || path === '/terms') {
            return '/';
        }
        return path;
    }, [location.state?.path]);

    useEffect(() => {
        getServiceTerms();
    }, []);

    const getServiceTerms = () => {
        setLoading(true);
        post(`custom/getServiceTerms`, {}).then((result) => {
            if (result.isSuccess && result.data) {
                const data = result.data;
                setTermRecord(data);
                setLoading(false);
                console.log('getAssignedSurveys result.isSuccess: ', result);
            } else {
                console.log('getAssignedSurveys result Error: ', result);
                setLoading(false);
            }
        });
    };

    const handleAgreeToTerms = () => {
        if (!agreedToTerms) {
            return;
        }

        const userDetails = getUserDetailsNotAsync();
        setActionLoading(true);
        post(`custom/updateServiceTerms`, { contactId: userDetails?.contact?.id }).then((result) => {
            setActionLoading(false);
            if (result.isSuccess && result.data === 'success') {
                if (userDetails) {
                    const updatedUserDetails = {
                        ...userDetails,
                        agreedToPortalTerms: true,
                        contact: userDetails.contact ? { ...userDetails.contact, agreedToPortalTerms: true } : userDetails.contact,
                    };
                    setUserDetailsNotAsync(updatedUserDetails);
                }
                navigate(redirectPath, { replace: true });
            }
        });
    };

    return (
        <MainContainer
            sx={{
                maxWidth: '865px !important',
                background: 'white',
                margin: 'auto',
                minHeight: '100vh',
                height: '100vh',
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    flex: '1 1 auto',
                    gap: { xs: '1.5rem', sm: '2rem' },
                }}
            >
                <Box sx={{ mb: { xs: '0.5rem', sm: '1rem' } }}>
                    <Box display="flex" justifyContent="center">
                        <img src={logo360} height={40} width={120} alt="Logo" />
                    </Box>
                </Box>
                <Box
                    display={'flex'}
                    justifyContent={'space-between'}
                    alignItems={'center'}
                    flexDirection={{
                        md: 'column',
                        xs: 'column',
                    }}
                    textAlign={'center'}
                    gap={'1rem'}
                >
                    <MainHeading sx={{ width: '100%' }}>PRIME360 PORTAL</MainHeading>
                    <Box sx={{ fontSize: '1.4rem' }}>{termRecord?.name}</Box>
                    <Box sx={{}}>Revision Date: {termRecord?.revisionDateString}</Box>
                </Box>
                <Divider
                    sx={(theme) => ({
                        margin: `0 0`,
                    })}
                />

                <Box
                    sx={(theme) => ({
                        flex: '1 1 auto',
                        overflow: 'hidden',
                        borderRadius: theme.typography.borderRadius.small,
                        border: `1px solid #e4e4e4`,
                        backgroundColor: '#fcfcfc',
                        display: 'flex',
                        flexDirection: 'column',
                        height: 'calc(100vh - 500px)',
                    })}
                >
                    <Box
                        sx={(theme) => ({
                            flex: '1 1 auto',
                            overflowY: 'auto',
                            padding: theme.typography.generic.xLarge,
                        })}
                    >
                        {loading ? (
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '12rem' }}>
                                <CircularProgress />
                            </Box>
                        ) : (
                            <RenderContent htmlString={termRecord?.body} />
                        )}
                    </Box>
                </Box>

                {userDetails && (
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: { xs: 'column', sm: 'row' },
                            alignItems: { xs: 'stretch', sm: 'center' },
                            justifyContent: 'space-between',
                            gap: '1rem',
                            paddingTop: { xs: '0.5rem', sm: '1rem' },
                        }}
                    >
                        <FormControlLabel
                            control={<Checkbox color="primary" checked={agreedToTerms} onChange={(event) => setAgreedToTerms(event.target.checked)} />}
                            label={<Typography variant="paraText3">I agree to the PRIME360 Portal Terms of Service</Typography>}
                            sx={{ marginLeft: 0 }}
                        />
                        <LoadingButton
                            variant="contained"
                            color="primary"
                            loading={actionLoading}
                            disabled={!agreedToTerms}
                            onClick={handleAgreeToTerms}
                            sx={{
                                minWidth: { xs: '100%', sm: '200px' },
                                opacity: agreedToTerms ? 1 : 0.5,
                            }}
                        >
                            Agree to Terms
                        </LoadingButton>
                    </Box>
                )}
            </Box>
        </MainContainer>
    );
}

export default TermsPage;
